import { TableCell, TableHead, TableRow } from '@mui/material'
import { useTranslation } from 'react-i18next'

export const InternalHoursLogsTableHead = (): JSX.Element => {
  const { t } = useTranslation('internalHours')

  return (
    <TableHead>
      <TableRow>
        <TableCell>{t('logs.columns.id')}</TableCell>
        <TableCell>{t('logs.columns.date')}</TableCell>
        <TableCell>{t('logs.columns.hours')}</TableCell>
        <TableCell>{t('logs.columns.reportType')}</TableCell>
        <TableCell>{t('logs.columns.leaveType')}</TableCell>
        <TableCell>{t('logs.columns.description')}</TableCell>
        <TableCell>{t('logs.columns.createdAt')}</TableCell>
        <TableCell />
      </TableRow>
    </TableHead>
  )
}
